import { Injectable } from "@angular/core";
import { NavigationProcessing, ProcessedNavNode, IUser } from "@logex/framework/lg-application";

@Injectable()
export class AppNavigationProcessing extends NavigationProcessing {
    evaluateAccess(node: ProcessedNavNode, parentNode: ProcessedNavNode, userInfo: IUser): void {
        return this.evaluateAccessStrategy_PermissionsHideNoAccess(node, parentNode, userInfo);
    }

    evaluateNumbering(node: ProcessedNavNode, depth: number, numberings: number[]): boolean {
        return this.evaluateNumberingStrategy_None(node, depth, numberings);
    }
}
